import { injectable } from "inversify";
import { Skin } from "../../model/playerConfiguration/Skin";

export interface ThemeUpdater {
  setTheme(skin: Skin): void;
}

@injectable()
export class ThemeUpdaterImpl implements ThemeUpdater {
  setTheme(skin?: Skin): void {
    if (!skin || skin.color === undefined) {
      return;
    }

    document.querySelector("body").style.setProperty("--theme-color", skin.color);
  }
}
